import classNames from 'classnames';
import React from 'react';

import { Maybe, Size } from '@/utils/common';

type TextDetailRowProps = {
    caption: string | React.ReactNode;
    value: Maybe<string> | React.ReactNode;
    size?: Size;
    className?: string;
    isResponsive?: boolean;
};
export const TextDetailRow = ({
    caption,
    value,
    size = 'small',
    className,
    isResponsive = true,
}: TextDetailRowProps) => {
    return (
        <div
            className={classNames(
                'flex justify-between items-center gap-2 text-white',
                {
                    't__body--b3': size === 'small',
                    't__body--b2': size === 'medium' || (size === 'large' && !isResponsive),
                    't__body--b3 md:t__body--b2': size === 'large' && isResponsive,
                },
                className,
            )}
        >
            <div>{caption}</div>
            <div>{value}</div>
        </div>
    );
};
